module.exports = __webpack_public_path__ + "img/treshaut.9776157.svg";